module.exports = __webpack_public_path__ + "static/media/flag_ca.4addefb6.svg";